import { userApi, baseDataApi } from '@/api';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { VUE_APP_BASE_API } from '@/utils/index';

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    user: '',
    avatar: '',
    introduction: '',
    roles: [],
    permissions: [],
    permissionBtns: [],
    userInfo: null,
    isSuperAdmin: true,
    customerList: [],
    clientCodeList: [],
    customerActivityList: [],
    clientCodeActivityList: [],
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_SUPER_ADMIN: (state, isSuperAdmin) => {
    state.isSuperAdmin = isSuperAdmin;
  },
  SET_USER_GROUP: (state, userGroup) => {
    state.userGroup = userGroup;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
    const permissionBtnList = [];
    permissions.forEach(a1 => {
      (a1.children || []).forEach(a2 => {
        (a2.children || []).forEach(a3 => {
          (a3.children || []).forEach(a4 => {
            // if (a4.permissionType == 'btn') {
            permissionBtnList.push(a4.code.toLocaleLowerCase());
            // }
          });
        });
      });
    });
    state.permissionBtns = permissionBtnList;
  },
  SET_CUSTOMERLIST: (state, list) => {
    state.customerList = list;
  },
  SET_CLIENTCODELIST: (state, list) => {
    state.clientCodeList = list;
  },

  SET_CUSTOMERACTIVITYLIST: (state, list) => {
    state.customerActivityList = list;
  },
  SET_CUSTOMERCODEACTIVITYLIST: (state, list) => {
    state.clientCodeActivityList = list;
  },
};

const actions = {
  setSuperAdmin({ commit }, isSuperAdmin) {
    commit('SET_SUPER_ADMIN', isSuperAdmin);
  },
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo);
  },
  setToken({ commit }, access_token) {
    commit('SET_TOKEN', access_token);
  },
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', 'admin-token');
      setToken('admin-token');
      resolve();
      // login({ username: username.trim(), password: password }).then(response => {
      //   const { data } = response
      //   commit('SET_TOKEN', data.token)
      //   setToken(data.token)
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    });
  },
  resetInfo({ commit }) {
    return new Promise((resolve, reject) => {
      removeToken();
      commit('SET_TOKEN', '');
      commit('SET_PERMISSIONS', []);
      resetRouter();
      commit('RESET_STATE');
      resolve();
    });
  },
  // get user info
  getInfo({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      userApi.getUserInfo().then(async response => {
          if (response.failed === true) {
            console.error(response);
            reject(response);
          }
          const data = {
            // roles: response.recentAccessTenantList || [],
            name: response.realName,
            user: response.loginName,
            avatar: response.imageUrl,
            introduction: response.title,
          };
          commit('SET_USER_INFO', Object.assign(response, data));
          const { name, user, avatar, introduction } = data;
          commit('SET_NAME', name);
          commit('SET_USER', user);
          commit('SET_AVATAR', avatar);
          commit('SET_INTRODUCTION', introduction);

          commit(
            'SET_SUPER_ADMIN',
            response.currentRoleLevel === 'site' && response.loginName === 'admin',
          );

          await dispatch('getUserPermission');
          await dispatch('getCustomerList');
          await dispatch('getCustomerActivityList');
          await dispatch('_getLovValuesByLovId');

          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  _getLovValuesByLovId() {
    return new Promise((resolve, reject) => {
      baseDataApi.getLovHeadersByLovCode({lovCode: 'TIME_DIFFERENCE'}).then(res => {
        if (res.lovId) {
          baseDataApi.getLovValuesByLovId({lovId: res.lovId}).then(resp => {
            sessionStorage.setItem('timeHour', isNaN(resp.content[0].value) ? 2 : resp.content[0].value);
            resolve();
          });
        }
      });
    });
  },
  // 获取用户菜单权限
  getUserPermission({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      userApi
        .getUserMenuTree()
        .then(response => {
          commit('SET_PERMISSIONS', response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 获取客户列表
  getCustomerList({ commit }) {
    return new Promise((resolve, reject) => {
      userApi.getUserList({
        customerType: 'C',
        page: 0,
        size: 999
      }).then(res => {
          commit('SET_CUSTOMERLIST', res.content.map(item => { return {...item, label: `${item.cusName}(${item.companyName})`, value: item.cusId}; }));
          commit('SET_CLIENTCODELIST', res.content.map(item => { return {...item, label: `${item.cusName}(${item.companyName})` , value: item.clientCode}; }));
          resolve(res);
      });
    });
  },
  // 获取未离场客户列表
  getCustomerActivityList({ commit }) {
    return new Promise((resolve, reject) => {
      userApi.getUserList({
        customerType: 'C',
        isDeparture: 0,
        page: 0,
        size: 999
      }).then(res => {
          commit('SET_CUSTOMERACTIVITYLIST', res.content.map(item => { return {...item, label: `${item.cusName}(${item.companyName})`, value: item.cusId}; }));
          commit('SET_CUSTOMERCODEACTIVITYLIST', res.content.map(item => { return {...item, label: `${item.cusName}(${item.companyName})`, value: item.clientCode}; }));
          resolve(res);
      });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      const LOGOUT_URL = `${VUE_APP_BASE_API()}/oauth/logout?access_token=${state.token}`;
      window.location.replace(LOGOUT_URL);
      // commonApi
      //   .logout({ access_token: state.token })
      //   .then(() => {
      removeToken();
      commit('SET_TOKEN', '');
      commit('SET_PERMISSIONS', []);
      resetRouter();
      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, {
        root: true,
      });

      resolve();
      // })
      // .catch(error => {
      //   removeToken();
      //   commit('SET_TOKEN', '');
      //   commit('SET_PERMISSIONS', []);
      //   reject(error);
      // });
    });
  },

  getUserGroupList({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      userApi['getUsersList']({
        userId: state.userInfo.id,
      }).then(res => {
        commit('SET_USER_GROUP', res);
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_PERMISSIONS', []);
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token';

    commit('SET_TOKEN', token);
    setToken(token);

    const { roles } = await dispatch('user/getInfo');
    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true,
    });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, {
      root: true,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
